import {
    ActionCreator,
    ActionCreatorsMapObject,
    bindActionCreators,
} from 'redux';
import { ReduxHooks } from 'utils/hooks/ReduxHooks';

type Action = ActionCreator<any>;

export function useBoundActions<T extends Action>(
    action: T,
): CutMiddleFunction<T>;
export function useBoundActions<T extends Action[]>(
    action: T,
): {
    [P in keyof T]: CutMiddleFunction<T[P]>;
};
export function useBoundActions<T extends ActionCreatorsMapObject>(
    action: T,
): {
    [P in keyof T]: CutMiddleFunction<T[P]>;
};
export function useBoundActions(actions) {
    const dispatch = ReduxHooks.useDispatch();

    const bindDispatch = (fn) => (...args) => dispatch(fn(...args));

    if (Array.isArray(actions)) {
        return actions.map(bindDispatch);
    }

    if (actions && typeof actions === 'object') {
        return bindActionCreators(actions, dispatch);
    }

    return bindDispatch(actions);
}
